import React from "react";
import styles from './Label.module.scss';

export interface IFormikSearchSelectorProps {
  label?: string;

}

const Label = (props: IFormikSearchSelectorProps) => {

  return (
    <span className={`${styles.label} label`}>
        {props.label}
      </span>
  );
};

Label.defaultProps = {
  label: "",
};

export default Label;
